import { useState } from 'react'
import classNames from 'classnames'

import type { BaseProps as ItemProps, AllowedVariants } from './AccordionItem'
import AccordionItem from './AccordionItem'

import style from './style.module.scss'

type Props = {
  items: ItemProps[]
  variant: AllowedVariants
  showBottomBorders?: boolean
  className?: string
}

function Accordion({
  items,
  variant,
  showBottomBorders = false,
  className,
}: Props) {
  const [expandedIndex, setIndex] = useState(-1)

  const handleToggleExpanded = (index: number) => {
    const newIndex = index === expandedIndex ? -1 : index
    setIndex(newIndex)
  }

  return (
    <ul
      className={classNames(style[variant], className)}
      data-testid='accordion'
    >
      {items?.map((item, index) => (
        <AccordionItem
          key={index}
          {...item}
          active={index === expandedIndex}
          index={index}
          showBottomBorders={showBottomBorders}
          toggleActive={handleToggleExpanded}
          variant={variant}
        />
      ))}
    </ul>
  )
}

export default Accordion
